<page-headline
    [module]="'historical-trends'"
    [moduleIcon]="'fa-chart-line'"
    [pageTitle]="'Historical Trends Home'"
>
</page-headline>

<app-transition-directory-cards
    [applicationPage]="'historical-trends'"
></app-transition-directory-cards>
